import { TimelineMax, TweenMax } from 'gsap/TweenMax';
import { transitionDuration } from '@/scripts/animation/animation-selectors';
import createEvent from '@/scripts/utils/create-event';
import clickOutside from 'click-outside';
import './Dropdown.scss';

const defaults = {
  element: null,
  triggerElement: '[data-role*=dropdown-title]',
  innerList: '[data-role*="dropdown-inner-list"]',
  innerListItem: '[data-role*="dropdown-inner-item"]',
  duration: transitionDuration,
};


export default class Dropdown {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.element = options.element;
    this.triggerElement = this.element.querySelector(options.triggerElement);
    this.innerList = this.element.querySelector(options.innerList);
    this.innerListItems = Array.from(this.element.querySelectorAll(options.innerListItem));
    this.duration = options.duration;
    this.durationStagger = options.duration * 0.8;
    this.activeStatus = false;
    this.animated = false;

    this.bindedToggle = this.toggleDropdown.bind(this);
    this.init();
  }

  init() {
    $(this.element).on('dropdown-toggle', () => {
      if (this.activeStatus) {
        this.toggleDropdown();
      }
    });
    this.triggerElement.addEventListener('click', this.toggleDropdown.bind(this));
    clickOutside(this.element, () => {
      if (this.activeStatus) {
        this.element.removeEventListener('toggleEnd', this.bindedToggle, { once: true });
        this.toggleDropdown();
      } else if (this.animated) {
        this.element.addEventListener('toggleEnd', this.bindedToggle, { once: true });
      }
    });
    TweenMax.set(this.innerList, { height: 0 });
  }

  toggleDropdown() {
    if (this.animated) return;
    this.animated = true;
    const tl = new TimelineMax({
      onComplete: () => {
        this.activeStatus = !this.activeStatus;
        this.animated = false;
        this.element.dispatchEvent(createEvent('toggleEnd'));
        window.dispatchEvent(createEvent('resize'));
      },
    });
    if (this.activeStatus) {
      this.element.classList.remove('is-active');
      tl
        .to(this.innerList, this.duration, { height: 0 })
        .staggerTo(this.innerListItems, this.durationStagger, { opacity: 0, y: 20 }, '.05', 0);
    } else {
      this.element.classList.add('is-active');
      tl
        .set(this.innerList, { height: 'auto' })
        .set(this.innerListItems, { opacity: 1, y: 30 })
        .from(this.innerList, this.duration, { height: 0 })
        .staggerTo(this.innerListItems, this.durationStagger, { opacity: 1, y: 0, clearProps: 'all' }, '.05', 0);
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/elements/Dropdown/Dropdown.js